import axios from "axios";
import { apiUrl } from "./http";

export function repairS3DocumentUrl(url) {
  if (!url || typeof url !== "string") {
    return "";
  }

  const trimmed = url.trim();

  if (!/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }

  if (/[?&]X-Amz-/i.test(trimmed)) {
    return trimmed;
  }

  try {
    const parsed = new URL(trimmed.split("?")[0]);
    let key = parsed.pathname.replace(/^\/+/, "");

    if (key.startsWith("applicants/") && !key.startsWith("documents/applicants/")) {
      key = `documents/${key}`;
    }

    return `https://${parsed.hostname}/${key}`;
  } catch {
    return trimmed.split("?")[0];
  }
}

export function getApplicantDocumentUrl(document) {
  if (!document) {
    return "";
  }

  const rawUrl = document.url || document.file_url || document.file || "";

  return repairS3DocumentUrl(rawUrl);
}

export async function loadApplicantForSummary() {
  const applicantId = localStorage.getItem("applicant_id");
  let apiData = null;

  if (applicantId) {
    try {
      const response = await axios.get(apiUrl(`/api/applicant/${applicantId}`));

      if (response.data?.success && response.data?.data) {
        apiData = response.data.data;
      }
    } catch (error) {
      console.error("Failed to load applicant summary from API", error);
    }
  }

  if (apiData) {
    localStorage.removeItem("persistedApplicant");
    return apiData;
  }

  const persisted = localStorage.getItem("persistedApplicant");

  if (persisted) {
    try {
      return JSON.parse(persisted);
    } catch (error) {
      console.error("Failed to parse persisted applicant", error);
    }
  }

  return null;
}
